import SensesDesktop from './SensesDesktop';

export default SensesDesktop;
export { SensesDesktop };
